import { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";
import { Contact as ContactSection } from "@/components/sections/Contact";

export default function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-black min-h-screen grain" data-testid="contact-page">
      <Seo
        title="Contact Aliwer | Request a Security Assessment"
        description="Get in touch with Aliwer to discuss your security needs or request a free consultation and security assessment."
        path="/contact"
      />
      <Navbar />
      <main id="main-content" tabIndex={-1} className="pt-24">
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
